import React from 'react';
// @ts-ignore
import styles from './SUKLCertificateHint.module.scss';
import Text from '../../../../Components/Base/Text/Text';

const SUKLCertificateHint: React.FC = ({}) => {
	return (
		<div className={styles.wrapper}>
			<Text tx='component.certificates.suklWhere' className={styles.bold} />
			<Text tx='component.certificates.clickOnLink' />
			<a target='_blank' href='https://pristupy.sukl.cz/ei_forms.html#/login'>
				https://pristupy.sukl.cz/ei_forms.html#/login
			</a>
			<Text tx='component.certificates.suklInstructions' />
			<Text tx='component.certificates.suklInstructions2' />
			<img className='img-fluid' src='/dist/hint/sukl.jpg' alt='sukl hint' />
		</div>
	);
};

export default SUKLCertificateHint;
